module.exports = __webpack_public_path__ + "img/books.add9acac.svg";